import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CertificateRoutingModule } from './certificate-routing.module';
import { CertificateComponent } from './certificate.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [CertificateComponent],
  imports: [CommonModule, CertificateRoutingModule, NgxSpinnerModule],
})
export class CertificateModule {}
